module.exports = __webpack_public_path__ + "img/product3.f116488d.png";